export const StopIcon: React.FC<any> = ({
   className,
   width = 18,
   height = 18,
}) => {
   return (
      <div
         className={`${className} fill-white`}
         dangerouslySetInnerHTML={{
            __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 18 18" fill="inherit">
        <g clip-path="url(#clip0_839_834)">
            <path d="M9 0C4.03725 0 0 4.03725 0 9C0 13.9628 4.03725 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03725 13.9628 0 9 0ZM9 15.75C5.2785 15.75 2.25 12.7215 2.25 9C2.25 5.2785 5.2785 2.25 9 2.25C12.7215 2.25 15.75 5.2785 15.75 9C15.75 12.7215 12.7215 15.75 9 15.75ZM12 7.5V10.5C12 11.3287 11.3287 12 10.5 12H7.5C6.67125 12 6 11.3287 6 10.5V7.5C6 6.67125 6.67125 6 7.5 6H10.5C11.3287 6 12 6.67125 12 7.5Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_839_834">
            <rect width="18" height="18" fill="inherit"/>
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
